import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHeling = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M9.578 7.084 6.978 18.8l23.43 5.199 2.6-11.715z"
    />
    <path
      fill="#B3E9B1"
      d="M20 19.29a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5M5.28 34h16.63a2.77 2.77 0 0 0 1.5-.45L34.82 26a2.63 2.63 0 0 0 .9-3.37A2.66 2.66 0 0 0 32 21.57l-9.25 5.49a2.33 2.33 0 0 0-2.34-2.32H9.83a4.85 4.85 0 0 0-2.18.51l-3.27 1.62a.68.68 0 0 0-.38.61v5.24A1.28 1.28 0 0 0 5.28 34"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M6.403 23.975a6.7 6.7 0 0 1 3.068-.735h10.643a2.94 2.94 0 0 1 2.916 2.971v-.005l-.5.004-.5-.006a1.94 1.94 0 0 0-1.922-1.964h.002v-.5l-.004.5h.002H9.47a5.7 5.7 0 0 0-2.613.625l-2.63 1.34-.454-.89zm13.705 4.195H12.82v1h7.294a2.94 2.94 0 0 0 2.916-2.959v.005l-.5-.006-.5.004a1.94 1.94 0 0 1-1.922 1.956m0 0h.002v.5l-.004-.5z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHeling);

export default ForwardRef;
